export const currenciesArray = [
  { label: "USD", value: "$" },
  { label: "EURO", value: "€" },
  { label: "Pound", value: "£" },
  { label: "AED", value: "AED" }
];
